



import { defineStore } from 'pinia';
import { IUserActivity } from '@/interfaces/UserActivity/IUserActivity';
import { getLiveUserActivityListener } from '@/api/services/LiveUserActivityService';






export const LiveUserActivityStore = defineStore('LiveUserActivityStore', {





    state: () => ({
        userActivities: [] as IUserActivity[],
        lastUpdated: 0,
        unsubscribe: null as (() => void) | null,
        checkInterval: null as number | null,


    }),





    actions: {
        async initialize() {
            console.log('Initializing LiveUserActivityStore');
            try {
                if (this.unsubscribe) {
                    this.unsubscribe();
                }

                this.unsubscribe = getLiveUserActivityListener((userActivities: IUserActivity[]) => {
                    const validUserActivities = userActivities.filter(activity => activity && activity.userActivityType);
                    const sortedUserActivities = validUserActivities.sort((a, b) => {
                        return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
                    });
                    if (sortedUserActivities.length > 0) {
                        this.lastUpdated = sortedUserActivities[0].createdAt
                    }
                    this.userActivities = sortedUserActivities;
                });

                this.startCheckInterval();
                console.log('LiveUserActivityStore initialized successfully');
                return true;
            } catch (error) {
                console.error('Error initializing LiveUserActivityStore:', error);
                return false;
            }
        },

        startCheckInterval() {
            if (this.checkInterval) {
                clearInterval(this.checkInterval);
            }
            this.checkInterval = setInterval(() => {
                this.checkTimeSinceLastUpdate();
            }, 15000);
        },

        checkTimeSinceLastUpdate() {
            if (this.lastUpdated) {
                const now = Math.floor(Date.now() / 1000);
                const lastUpdatedInSeconds = this.lastUpdated;

                if (now - lastUpdatedInSeconds > 15) {
                    if (this.userActivities && this.userActivities.length > 0) {
                        const lastActivity = this.userActivities.pop();
                        if (lastActivity) {
                            this.userActivities.unshift(lastActivity);
                        }
                        this.lastUpdated = now;
                    }
                }
            }
        },


        stopListening() {
            if (this.unsubscribe) {
                this.unsubscribe();
                this.unsubscribe = null;
            }
            if (this.checkInterval) {
                clearInterval(this.checkInterval);
                this.checkInterval = null;
            }
        },




        
    }
});
